import React from "react";
// import { useSubheader } from "../../_metronic/layout";

const ContactUs = () => {
//   const suhbeader = useSubheader();
//   suhbeader.setTitle("Customers");

  return <>Contact us</>;
};

export default ContactUs